<script>
import TagsComponent from '@kvass/custom-fields/src/Fields/Tags'
export default TagsComponent
</script>
